import {
	getActionProbability,
	getActionStruct,
	getInitComboDraw,
	getInitComboDrawRange,
	getMaxEqr,
	getRangeStruct,
} from '../../helpers'
import api from '../../../../axios'
import { viewerConstants } from '../../../_reducers/viewer'
import { getNextActions, setActiveViewerRequestQuery, setStrategyFilters } from '../../viewer'
import { actions as reportActions } from '../../../slices/Reports/reports'
import { history } from '../../../../_history'
import { constants } from '../../../../Viewer/viewModeConstants'

/**
 * This is unique action for every node action pressed
 * If the next action is flop there is no request to server
 * Otherwise request with specified query is performed
 * INPUT: QUERY, spotId, ACTION_TYPE, ACTION_INDEX
 **/

export const getNodeInfo = (query, spotId, street, i, chooseIndex) => (dispatch, getState) => {
	dispatch({ type: viewerConstants.VIEWER_REQUEST }) // request is pending

	if (query === undefined || query === '') {
		// check if query is not undefined or null
		dispatch({ type: viewerConstants.VIEWER_PASS })

		return
	}

	if (street === 'flop' || street === 'turn' || street === 'river') {
		dispatch({ type: viewerConstants.VIEWER_SHOW_BOARD, q: query, id: spotId, a: street, i, chooseIndex })
	} else {
		dispatch(setActiveViewerRequestQuery(query))

		const payload = {
			id: spotId,
			q: query,
		}

		const { threshold } = getState().preferences.dataNew.common.matrix
		const { board, blockedReports } = getState().view
		const hash = window.location.hash

		api
			.post('get_strategy', payload, {}, null)
			.then(({ data }) => {
				if (hash) {
					history.push(`?id=${spotId}&q=${data.currentQuery}${hash}`)
				} else {
					history.push(`?id=${spotId}&q=${data.currentQuery}#${constants.ONE_PLAYER}-${constants.STRATEGY}`)
				}

				const comboDrawSet = getInitComboDraw(data, threshold)
				const comboDrawSetRange = getInitComboDrawRange(data, threshold)

				const action_struct = getActionStruct(data, threshold)
				const actionsWithProb = getActionProbability(data.actions, data.abs, board, query)
				const action_range_struct = [
					getRangeStruct({
						combos: data.combos,
						draws: data.draw,
						abs: data.abs,
						eq: data.equity,
						ev: data.main_ev,
						prob: data.prob,
						eqr: data.main_eqr,
					}), // always for hero, who makes the action now!
					getRangeStruct({
						combos: data.combos,
						draws: data.draw,
						abs: data.villain_abs,
						eq: data.villain_equity,
						ev: null,
						prob: data.villain_prob,
						eqr: data.villain_main_eqr,
					}), // always for villain, who have already made his action
				]

				const rakeRenderFilter =
					data.rake_names_all.length === 0 ? [] : data.rake_names_all.map((rake) => rake.rake_open_name)
				const openRaiseRenderFilter =
					data.fp_open_names_all.length === 0 ? [] : data.fp_open_names_all.map((openRaise) => openRaise.rake_open_name)

				dispatch(reportActions.setRakeRenderFilter(rakeRenderFilter))
				dispatch(reportActions.setOpenRaiseRenderFilter(openRaiseRenderFilter))

				dispatch(setStrategyFilters({ filterType: 'activeActions', filterData: [] }))

				dispatch({
					type: viewerConstants.SET_ACTIVE_QUERY_TRACE_INDEX,
					payload: -1,
				})

				dispatch({
					type: viewerConstants.SET_ACTIVE_CARD_TRACE_INDEX,
					payload: -1,
				})

				/* set active query with curQuery value*/
				// dispatch({
				// 	type: viewerConstants.SET_ACTIVE_CARD_QUERY,
				// 	query,
				// })

				dispatch({
					type: viewerConstants.SET_EQR,
					payload: { hero: getMaxEqr(data.main_eqr), villain: getMaxEqr(data.villain_main_eqr) },
				})

				dispatch({ type: viewerConstants.RESET_ERROR_DATA, payload: [] })

				dispatch({
					type: viewerConstants.VIEWER_SUCCESS,
					action_struct,
					action_range_struct,
					player: data.player,
					villain_player: data.villain_player,
					trace: data.trace,
					next_actions: getNextActions(data),
					curPath: query,
					comboSet: comboDrawSet.comboSet,
					drawSet: comboDrawSet.drawSet,
					comboSetRange: comboDrawSetRange.comboSet,
					drawSetRange: comboDrawSetRange.drawSet,
					libraryName: data.libraryName,
					spotId: data.spotId,
					spotName: data.spotName,
					currentQuery: data.currentQuery,
					abs: data.abs,
					ev: data.main_ev,
					villain_abs: data.villain_abs,
					villain_equity: data.villain_equity,
					combos: data.combos,
					draw: data.draw,
					next_node: data.next_node,
					table: data.table,
					actions: actionsWithProb,
					equity: data.equity,
					stacks: data.stacks,
					allCombos: comboDrawSet.comboSet,
					allDraws: comboDrawSet.drawSet,
					combosOrder: data.combosOrder,
					activeQuery: query,
					prob: data.prob,
					villainProb: data.villain_prob,
				})
			})
			.catch((error) => {
				if (error.response?.status === 419) {
					if (hash) {
						history.push(`?id=${spotId}&q=${query}${hash}`)
					} else {
						history.push(`?id=${spotId}&q=${query}#${constants.ONE_PLAYER}-${constants.STRATEGY}`)
					}

					dispatch({
						type: viewerConstants.SET_CURRENT_QUERY,
						payload: query,
					})

					dispatch({
						type: viewerConstants.SET_ERROR_DATA,
						payload: window.location.hash.slice(1),
					})
				}
			})
	}
}
